
import React from 'react';
import { Zap, Shield, CheckCircle } from 'lucide-react';

export const WorkflowSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-bold mb-4">How Our Platform Works</h2>
          <p className="text-lg text-muted-foreground">
            Our intuitive interface guides you through creating a personalized emergency plan in minutes
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Conversation Interface */}
          <div className="rounded-xl overflow-hidden shadow-md border border-border">
            <div className="bg-primary/5 p-4 border-b border-border">
              <h3 className="text-xl font-semibold">Simple Conversation Interface</h3>
            </div>
            <div className="p-2">
              <img 
                src="/lovable-uploads/82093515-4b12-42c4-98ab-3761c40c3064.png" 
                alt="AI conversation interface" 
                className="w-full rounded-lg shadow-sm"
              />
            </div>
            <div className="p-6">
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="mt-1 p-1 rounded-full bg-primary/10">
                    <Zap size={18} className="text-primary" />
                  </div>
                  <span>Quick 15-minute interview that adapts to your specific circumstances</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="mt-1 p-1 rounded-full bg-primary/10">
                    <Shield size={18} className="text-primary" />
                  </div>
                  <span>Questions tailored to your family structure, location, and needs</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="mt-1 p-1 rounded-full bg-primary/10">
                    <CheckCircle size={18} className="text-primary" />
                  </div>
                  <span>Creates a plan based on your responses</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Dashboard Interface */}
          <div className="rounded-xl overflow-hidden shadow-md border border-border">
            <div className="bg-primary/5 p-4 border-b border-border">
              <h3 className="text-xl font-semibold">Intuitive Dashboard</h3>
            </div>
            <div className="p-2">
              <img 
                src="/lovable-uploads/daa53f2a-ec19-4c13-b828-32fe29270fca.png" 
                alt="Dashboard interface" 
                className="w-full rounded-lg shadow-sm"
              />
            </div>
            <div className="p-6">
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="mt-1 p-1 rounded-full bg-primary/10">
                    <Zap size={18} className="text-primary" />
                  </div>
                  <span>Quick Actions for immediate access to your most important tools</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="mt-1 p-1 rounded-full bg-primary/10">
                    <Shield size={18} className="text-primary" />
                  </div>
                  <span>Risk assessment based on your location and inputs</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="mt-1 p-1 rounded-full bg-primary/10">
                    <CheckCircle size={18} className="text-primary" />
                  </div>
                  <span>Track your plan completion status and recent activity</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-emergency-50 p-8 rounded-xl text-center max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold mb-3">From Conversation to Customized Plan</h3>
          <p className="text-muted-foreground mb-0">
            Our platform combines your inputs with emergency planning knowledge to create a plan 
            that's tailored to your specific situation—all in about 15 minutes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
